export default {"src":"/_next/static/media/header_ongoing.a66c9458.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};